import { CREATE_NOTIFICATION } from './NotificationConstants'



export const addNotification = (title, message, level) => {
    return {
        type: CREATE_NOTIFICATION,
        title: title,
        message: message,
        level: level
    }
}

export const addNotifSuccess = (message, title) => {
    return addNotification(title, message, 'success')
}

export const addNotifError = (message, title) => {
    return addNotification(title, message, 'error')
}



// WEBPACK FOOTER //
// ./src/notification/NotificationActions.js